/* flow */
import React, { Component, PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'

type Props = {
  range: DateRange,
  maxRange: DateRange,
  filterDate: (range: DateRange, m: ?number) => void
}

class DateRangePicker extends Component<Props> {
  componentWillReceiveProps = ({ range: [start, end] }: Props) => {
    const  { startCalendar, endCalendar } = this
    startCalendar.setSelected(moment(start))
    endCalendar.setSelected(moment(end))
  } 

  handleChangeStart = (date, { type }: SyntheticEvent<T> = {}) => {
    const { range: [, end], filterDate } = this.props
    type && date && filterDate([date.toDate(), end])
  }

  handleChangeEnd = (date, { type }: SyntheticEvent<T> = {}) => {
    const { range: [start, ], filterDate} = this.props
    type && date && filterDate([start, date.toDate()])
  }
 
  render () {
    const { range: [start, end], maxRange: [min, max] } = this.props
    return (
      <div className='DateRangePicker'>
        <DatePicker
          ref={c => this.startCalendar = c}
          customInput={<CustomInput />}
          selected={moment(start)}
          minDate={moment(min)}
          maxDate={moment(end).subtract(1, 'days')}
          onChange={this.handleChangeStart}
        />
        <DatePicker
          ref={c => this.endCalendar = c}
          customInput={<CustomInput />}
          selected={moment(end)}
          minDate={moment(start).add(1, 'days')}
          maxDate={moment(max)}
          onChange={this.handleChangeEnd}
        />
      </div>
    )
  }
}

export default DateRangePicker

type InputProps = {
  onClick: func,
  onChange: func,
  value: string
}

export class CustomInput extends PureComponent<InputProps, InputState> {
  render () {
    const { onClick, onChange, value } = this.props
    return (
      <div className='ui icon input'>
        <input type='text'
          value={value}
          onClick={onClick}
          onChange={onChange}
          placeholder={moment().format('L')}
         />
        <i aria-hidden='true' className='calendar icon'></i>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/DatePicker.js